import { render, staticRenderFns } from "./CommercialTerms.vue?vue&type=template&id=2d92a78c&"
import script from "./CommercialTerms.vue?vue&type=script&lang=js&"
export * from "./CommercialTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports